import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { TRCNextSteps } from 'app/shared/models/tRCNextSteps.model';

@Component({
  selector: 'jhi-eappreg-confirm-text',
  templateUrl: './eappreg-confirm-text.component.html',
  styleUrls: ['./eappreg-confirm-text.component.scss']
})
export class EappregConfirmTextComponent implements OnInit {
  tRCAppForm = JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "{}")
  trcNextSteps: TRCNextSteps = JSON.parse(sessionStorage.getItem("TRCNextSteps") ?? "");
  serverUrl = "" ;
  constructor(@Inject(DOCUMENT) private document: Document,) {
     this.serverUrl = `${this.document.location.origin}`   }

  ngOnInit(): void {
    const temp="eappreg"
  }
  get sessionStorage() : any {
    return sessionStorage ;
  }
}
